import { CustomTokenInfo } from '@/utils/helpers'

export const CURRENT_TYPE = {
  deposit: 'deposit',
  withdraw: 'withdraw',
}

export type ViewProps = {
  currentType: string;
  tokenOptions: CustomTokenInfo[];
  onClickType: (newType: string) => void;
  onPickAToken: (token: CustomTokenInfo) => void;
  topTokensPickerSlot: JSX.Element | null;
  isOpenMethodSelection: boolean;
  onCloseMethodSelection: () => void;
  onSelectMethod: (newMethod: string) => void;
  showEuro2024Banner: boolean;
}
